import { render, staticRenderFns } from "./payment-type-spendingcards.vue?vue&type=template&id=81ff6afc&scoped=true&"
import script from "./payment-type-spendingcards.vue?vue&type=script&lang=js&"
export * from "./payment-type-spendingcards.vue?vue&type=script&lang=js&"
import style0 from "./payment-type-spendingcards.vue?vue&type=style&index=0&id=81ff6afc&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "81ff6afc",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VList } from 'vuetify/lib/components/VList';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VContainer,VList,VProgressCircular,VRow,VTextField})
